import { Typography, Grid } from '@mui/material'
import React from 'react'
import { ControlledTextField } from '../ControlledTextField'
import { BrandTypeSelect } from './BrandTypeSelect'
import { FieldContainer } from '../FieldContainer'

export const BrandDataFields = () => {
  return (
    <FieldContainer>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant='h6'>Brand</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <BrandTypeSelect />
        </Grid>
        <Grid item xs={12} md={6}>
          <ControlledTextField
            name='companyName'
            label='Name of Agency / Company'
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ControlledTextField name='brandName' label='Brand Name' />
        </Grid>
      </Grid>
    </FieldContainer>
  )
}
